import type { UcCtaBannerSection } from '../../../lib/useCaseQueries';
import { UseCaseCtaButton } from '../UseCaseCtaButton';

type UcCtaBannerSectionProps = {
  data: UcCtaBannerSection;
};

export function UcCtaBannerSection({ data }: UcCtaBannerSectionProps) {
  return (
    <section className="final-cta band-dark" id="cta">
      <div className="container">
        <div className="content-measure">
          {data.eyebrow && <div className="cta-eyebrow">{data.eyebrow}</div>}
          <h2>
            {data.headingMain}
            {data.headingAccent && (
              <>
                <br />
                <em>{data.headingAccent}</em>
              </>
            )}
          </h2>
          {data.subtext && <p>{data.subtext}</p>}
          <div className="cta-actions">
            {data.primaryCtaLabel && data.primaryCtaUrl && (
              <UseCaseCtaButton
                label={data.primaryCtaLabel}
                url={data.primaryCtaUrl}
                variant="primary"
              />
            )}
            {data.secondaryCtaLabel && data.secondaryCtaUrl && (
              <UseCaseCtaButton
                label={data.secondaryCtaLabel}
                url={data.secondaryCtaUrl}
                variant="ghost"
              />
            )}
          </div>
          {data.footnote && <div className="cta-note">{data.footnote}</div>}
        </div>
      </div>
    </section>
  );
}
